<form [formGroup]="addOrganizationForm" class="contact-form" (ngSubmit)="onSubmit()">

    <ms-input-label [isRequired]="isFieldRequired(addOrganizationForm, 'organizationName')" [labelText]="'Organization Name'" />
    <input type="text" id="organizationName" [required]="isFieldRequired(addOrganizationForm, 'organizationName')" maxlength="100"
        formControlName="organizationName" class="form-control"
        [class.is-invalid]="addOrganizationForm.get('organizationName')?.invalid && addOrganizationForm.get('organizationName')?.touched"
        [class.is-valid]="addOrganizationForm.get('organizationName')?.valid && addOrganizationForm.get('organizationName')?.touched && addOrganizationForm.get('organizationName')?.value !== ''" />
    @if(addOrganizationForm.get('organizationName')?.invalid && addOrganizationForm.get('organizationName')?.touched) {
    <div class="error-messages">
        @if(addOrganizationForm.get('organizationName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.OrganizationRequired}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(addOrganizationForm, 'replyToEmailAddress')"
        [labelText]="'Reply-To Email Address'" class="mt-3" />
    <input type="email" id="replyToEmailAddress" [required]="isFieldRequired(addOrganizationForm, 'replyToEmailAddress')"
        maxlength="255" formControlName="replyToEmailAddress" class="form-control" placeholder="noreply@example.com"
        [class.is-invalid]="addOrganizationForm.get('replyToEmailAddress')?.invalid && addOrganizationForm.get('replyToEmailAddress')?.touched"
        [class.is-valid]="addOrganizationForm.get('replyToEmailAddress')?.valid && addOrganizationForm.get('replyToEmailAddress')?.touched && addOrganizationForm.get('replyToEmailAddress')?.value !== ''" />
    @if(addOrganizationForm.get('replyToEmailAddress')?.invalid && addOrganizationForm.get('replyToEmailAddress')?.touched) {
    <div class="error-messages">
        @if(addOrganizationForm.get('replyToEmailAddress')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.OrganizationReplyToEmailAddressRequired}}</p>
        }
        @if(addOrganizationForm.get('replyToEmailAddress')?.errors?.['email']) {
        <p class="text-danger text-start pt-1 mb-0">{{addOrganizationForm.get('replyToEmailAddress')?.errors?.['email']?.message}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(addOrganizationForm, 'slug')" [labelText]="'Domain Path'" class="mt-3" />
    <input type="text" id="slug" [required]="isFieldRequired(addOrganizationForm, 'slug')" maxlength="50" formControlName="slug"
        class="form-control"
        [class.is-invalid]="addOrganizationForm.get('slug')?.invalid && addOrganizationForm.get('slug')?.touched"
        [class.is-valid]="addOrganizationForm.get('slug')?.valid && addOrganizationForm.get('slug')?.touched && addOrganizationForm.get('slug')?.value !== ''" />
    @if(addOrganizationForm.get('slug')?.invalid && addOrganizationForm.get('slug')?.touched) {
    <div class="error-messages">
        @if(addOrganizationForm.get('slug')?.errors?.['required']) {
        <p class="text-danger text-start pt-1">{{FormValidatorMessages.SlugRequired}}</p>
        }
        @if(addOrganizationForm.get('slug')?.errors?.['slug']) {
        <p class="text-danger text-start pt-1">{{addOrganizationForm.get('slug')?.errors?.['slug']?.message}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(addOrganizationForm, 'billingStatus')" [labelText]="'Billing Status'" class="mt-3" />
    <select class="form-select" formControlName="billingStatus">
        @for (option of billingStatusOptions; track option.key) {
        <option [value]="option.value">
            {{ option.label }}
        </option>
        }
    </select>

    <ms-input-label [isRequired]="isFieldRequired(addOrganizationForm, 'pricingTier')" [labelText]="'Pricing Tier'" class="mt-3" />
    <select class="form-select" formControlName="pricingTier">
        @for (option of pricingTierOptions; track option.key) {
        <option [value]="option.value">
            {{ option.label }}
        </option>
        }
    </select>

    <ms-input-label [labelText]="'Timezone'" [isRequired]="isFieldRequired(addOrganizationForm, 'timezone')" class="mt-3" />
    <ms-timezone-dropdown formControlName="timezone" />

    <ms-input-label [labelText]="'Currency'" [isRequired]="isFieldRequired(addOrganizationForm, 'currency')" class="mt-3" />
    <ms-currency-dropdown formControlName="currency" />

    <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="btn btn-primary">
            @if(isSubmitting) {
            <div class="spinner-border text-light spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            } @else {
                Submit
            }
        </button>
    </div>
</form>